<template>
  <ul class="navbar-nav mr-auto">
    <li class="nav-item">
      <router-link
        to="/dashboard"
        class="nav-link"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Dashboard</router-link
      >
    </li>
    <li class="nav-item">
      <router-link
        to="/calendar"
        class="nav-link"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Calendar</router-link
      >
    </li>
    <li
      class="nav-item"
      v-if="$can({ key: 'clients', expectedPermission: 'view' })"
    >
      <router-link
        :to="{ name: 'patients' }"
        class="nav-link"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Clients</router-link
      >
    </li>
    <li class="nav-item">
      <router-link
        :to="{ name: 'providers' }"
        class="nav-link"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Providers</router-link
      >
    </li>
    <li class="nav-item">
      <router-link
        to="/tasks"
        class="nav-link"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Tasks</router-link
      >
    </li>
    <profile-nav />
  </ul>
</template>
<script>
import { default as ProfileNav } from "./Profile";
export default {
  components: {
    ProfileNav,
  },
};
</script>
